import { observer } from "mobx-react-lite";
import { Button, Checkbox, CheckboxProps, Grid } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../app/layout/PageHeader";
import { useStore } from "../../app/stores/store";

const fields = [
  'firstName',
  'lastName',
  'companyName',
  'workPhone',
  'homePhone',
  'mobilePhone',
  'email',
  'address1',
  'address2',
  'city',
  'state',
  'postalCode'
]

export class CustomerExportValues {
  values: { [key: string]: boolean};

  constructor() {
    this.values = {};
    for (let v of fields) {
      this.values[v] = true;
    }
  };

  updateValue = (name: string, checked: boolean) => {
    this.values[name] = checked;
  }

  getFields = () => {
    const f = [];

    for (let name of fields) {
      if (this.values[name]) {
        f.push(name);
      }
    }

    return f;
  }
}

interface Props {
  onSubmit: (values: CustomerExportValues) => void;
  values: CustomerExportValues;
}

export default observer(function CustomerExportSelection({
  onSubmit,
  values
}: Props) {
  const { t } = useTranslation(["common", "customer"]);
  const { modalStore } = useStore();

  const handleClick = (e: React.MouseEvent, d: CheckboxProps) => {
    values.updateValue(d.name as string, d.checked ?? false);
  }

  return (
    <>
      <PageHeader
        type="h1"
        header={t("export.heading", { ns: "customer" })}
        divider={true}
        addTitle={false}
      />
      <Grid>
        {fields.map(f => (
          <Grid.Row>
            <Checkbox name={f} label={t(`export.${f}`, { ns: 'customer' })} onClick={handleClick} defaultChecked />
          </Grid.Row>
        ))}
        <Grid.Row>
          <Grid.Column>
            <Button
              className="save_button"
              type="button"
              color="green"
              content={` ${t("export.cta", { ns: "customer" })}`}
              onClick={() => {
                onSubmit(values);
                modalStore.closeModal();
              }}
            />
            <Button
              className="save_button"
              icon="cancel"
              type="reset"
              content={t("cancel", { ns: "common" })}
              onClick={() => {
                modalStore.closeModal();
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
});
